import React from 'react';


const featuresData = [
    {
        iconClass: 'flaticon-volunteer',
        title: 'Become a Partner',
        description: 'Alone, we can help a few. Together, we can save hundreds of lives.'
    },
    {
        iconClass: 'flaticon-solidarity',
        title: 'Donate Today',
        description: 'Alone, your gift is powerful. Together, we can fund every surgery a child needs.'
    },
    {
        iconClass: 'flaticon-charity',
        title: 'Share Their Stories',
        description: 'Alone, one voice is quiet. Together, we can shout hope to the world.'
    }
];


const FeatureSection = () => {
    return (
        <section className="wpo-features-area">
            <div className="container">
                <div className="features-wrap">
                    <div className="row">
                        {featuresData.map((feature, index) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={index}>
                                <div className="feature-item-wrap">
                                    <div className="feature-item">
                                        <div className="feature-icon">
                                            <div className="icon">
                                                <i className={`fi ${feature.iconClass}`}></i>
                                            </div>
                                        </div>
                                        <div className="feature-text">
                                            <h2>{feature.title}</h2>
                                            <p>{feature.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )

}

export default FeatureSection;